import { Item } from "../model/Item";
import { getItem } from "./getItem";

export function getItems(itemIds: number[]): Promise<Item[]> {
    return Promise.all(itemIds.map(getItem));
}
